$(function () {

    /**
     * ADD TO CART
     */

    $('.addtocart').on('submit', (e) => {
        e.preventDefault();

        $.ajax({
            'url': $(e.target).attr('action'),
            'type': 'POST',
            'data': $(e.target).serialize(),
            'beforeSend': function () {
                $('.product__messages').html('');
            },
            'success': function (data) {
                if (data.success) {
                    $('body').css('overflow', 'hidden');
                    $('.js-added').html(data.html);
                    $('.lightbox-product').addClass('open');
                    $('.lightbox-product .lightbox-content').addClass('slide-in-top');
                    if (data.cartCount > 0) {
                        $('.js__cart_count').html(data.cartCount);
                        $('.js__cart_count').removeClass('hide');
                    } else {
                        $('.js__cart_count').addClass('hide');
                    }
                    if (data.datalayer) {
                        $.fn.pushDatalayer(data.datalayer, true);
                    }
                } else {
                    console.error(data);
                }
            },
            'error': function (e) {
                console.error('Something wrong!', e);
            }
        });
    });

    /**
     * FIN - ADD TO CART
     */


    /**
     * QUANTITY
     */

    function incrementValue(e) {
        e.preventDefault();
        var parent = $(e.currentTarget).siblings('.qty__input');
        var currentVal = parseInt(parent.val(), 10);

        if (!isNaN(currentVal)) {
            parent.val(currentVal + 1);
        } else {
            parent.val(0);
        }

        parent.trigger('change');
    }

    function decrementValue(e) {
        e.preventDefault();
        var parent = $(e.currentTarget).siblings('.qty__input');
        var currentVal = parseInt(parent.val(), 10);
        var min = parent.attr('min');

        if (!isNaN(currentVal) && currentVal > min) {
            parent.val(currentVal - 1);
        } else {
            parent.val(min);
        }
        parent.trigger('change');
    }

    $(document).on('click', '.qty__add', function (e) {
        e.preventDefault();
        incrementValue(e);
    });

    $(document).on('click', '.qty__minus', function (e) {
        e.preventDefault();
        decrementValue(e);
    });

    $(document).on('change', '.qty__input', function (e) {
        e.preventDefault();
        var currentVal = parseInt($(e.currentTarget).val(), 10);
        var min = $(e.currentTarget).attr('min');
        var max = $(e.currentTarget).attr('max');

        if (!isNaN(currentVal)) {
            if (currentVal > min) {
                $(e.currentTarget).siblings('.qty__minus').fadeTo("fast", 1);
            } else {
                $(e.currentTarget).val(min);
                $(e.currentTarget).siblings('.qty__minus').fadeTo("fast", 0.5);
            }
            if (currentVal < max) {
                $(e.currentTarget).siblings('.qty__add').fadeTo("fast", 1);
            } else {
                $(e.currentTarget).val(max);
                $(e.currentTarget).siblings('.qty__add').fadeTo("fast", 0.5);
            }
        } else {
            $(e.currentTarget).val(min);
            $(e.currentTarget).siblings('.qty__minus').fadeTo("fast", 0.5);
            $(e.currentTarget).siblings('.qty__add').fadeTo("fast", 1);
        }
    });

    /**
     * FIN - QUANTITY
     */

});

